const GSC_SHARED_SEARCH_KEYS = ["dateRange", "from", "to", "compare"] as const;

/** Carry shared date params across GSC tabs. Compare domains stay out of nav links. */
export const buildGscSectionHref = (
  path: string,
  currentSearch: string,
): string => {
  const current = new URLSearchParams(currentSearch);
  const next = new URLSearchParams();

  for (const key of GSC_SHARED_SEARCH_KEYS) {
    const value = current.get(key);
    if (value) next.set(key, value);
  }

  const query = next.toString();
  return query ? `${path}?${query}` : path;
};
